export default __webpack_public_path__ + "relation-text-extract1787d7.png";